import React from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';
import TutorialInfo from 'components/presenters/tutorial/TutorialInfo';
import {Layout} from './style';
export default function TutorialLayout() {
    return (
        <Layout>
            <TitleHeader title={"모티너스 사용설명서"} />
            <TutorialInfo />
        </Layout>
    )
}
